import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Dialog, Dropdown } from "../../Components/Bootstrap";
import { ListGroup, Form, FloatingLabel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import {
  faAngleRight,
  faCircleInfo,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

function Setting() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [reloadToggle, setReloadToggle] = useState(false);
  const [reloadList, setReloadList] = useState([
    { value: "15", text: "15초" },
    { value: "30", text: "30초" },
    { value: "45", text: "45초" },
    { value: "60", text: "60초" },
    { value: "00", text: "사용안함" },
  ]);
  const [reloadValue, setReloadValue] = useState("");
  const [passworkChangeToggle, setPassworkChangeToggle] = useState(false);
  const [passwordInputs, setPasswordInputs] = useState({
    currentPw: "",
    newPw: "",
    confirmPw: "",
  });
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{9,}$/;

  // 새로고침 간격 변경
  const SaveReload = () => {
    try {
      if (!reloadValue) {
        throw new Error("간격을 선택하세요.");
      }
      Commons.Storages("set", "saves", {
        ...Commons.Storages("get", "saves"),
        reloadTime: reloadValue,
      });
      Commons.Toast("success", "저장되었습니다.");
      setReloadToggle(false);
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 비밀번호 변경
  const ChangePasswork = async () => {
    setLoading(true);

    try {
      if (!passwordInputs.currentPw) {
        throw new Error("현재 비밀번호를 입력하세요.");
      } else if (!passwordInputs.newPw) {
        throw new Error("새 비밀번호를 입력하세요.");
      } else if (!passwordInputs.confirmPw) {
        throw new Error("비밀번호 확인을 입력하세요.");
      } else if (
        !passwordRegex.test(passwordInputs.newPw) &&
        !passwordRegex.test(passwordInputs.confirmPw)
      ) {
        throw new Error("비밀번호 조건을 확인하세요.");
      } else if (passwordInputs.newPw !== passwordInputs.confirmPw) {
        throw new Error("비밀번호와 비밀번호 확인이 다릅니다.");
      }

      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Common.ChangePassword,
        {
          pw: passwordInputs.currentPw,
          newPw: passwordInputs.newPw,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("비밀번호 변경: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Discord Password") {
          throw new Error("현재 비밀번호가 틀립니다.");
        } else if (data === "Ok") {
          setPassworkChangeToggle(false);
          Commons.Toast("success", "저장되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e.message);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ListGroup className="custom-listGroup">
        <ListGroup.Item
          className="custom-listGroup-item mb-1"
          action
          onClick={() => navigate("/Notices")}
        >
          공지사항
          <FontAwesomeIcon icon={faAngleRight} />
        </ListGroup.Item>
        <ListGroup.Item
          className="custom-listGroup-item mb-1"
          action
          onClick={() => setReloadToggle(true)}
        >
          새로고침 간격
          <FontAwesomeIcon icon={faAngleRight} />
        </ListGroup.Item>
        <ListGroup.Item
          className="custom-listGroup-item mb-1"
          action
          onClick={() => setPassworkChangeToggle(true)}
        >
          비밀번호 변경
          <FontAwesomeIcon icon={faAngleRight} />
        </ListGroup.Item>
        <ListGroup.Item
          className="custom-listGroup-item mb-1"
          action
          onClick={() =>
            Commons.Toast("info", Commons.Storages("get", "version").version)
          }
        >
          버전 정보
          <FontAwesomeIcon icon={faCircleInfo} />
        </ListGroup.Item>
        <ListGroup.Item
          className="custom-listGroup-item mb-1"
          action
          onClick={async () => {
            await IndexedDb.ClearDb("AuthList");
            await IndexedDb.ClearDb("LoginInfo");
            await IndexedDb.ClearDb("MenuList");
            navigate("/");
          }}
        >
          로그아웃
          <FontAwesomeIcon icon={faRightFromBracket} />
        </ListGroup.Item>
      </ListGroup>
      <Dialog
        title="새로고침 간격"
        show={reloadToggle}
        onHide={() => setReloadToggle(false)}
        onSumit={SaveReload}
      >
        <Dropdown
          title="간격을 선택하세요."
          variant="outline-primary"
          items={reloadList}
          onChange={(e) => setReloadValue(e)}
        />
      </Dialog>
      <Dialog
        title="비밀번호 변경"
        show={passworkChangeToggle}
        onHide={() => setPassworkChangeToggle(false)}
        onClose={() =>
          setPasswordInputs({
            ...passwordInputs,
            currentPw: "",
            newPw: "",
            confirmPw: "",
          })
        }
        onSumit={ChangePasswork}
      >
        <Form>
          <FloatingLabel className="pb-2" label="현재 비밀번호">
            <Form.Control
              placeholder="현재 비밀번호"
              type="password"
              value={passwordInputs.currentPw}
              onChange={(e) =>
                setPasswordInputs({
                  ...passwordInputs,
                  currentPw: e.target.value,
                })
              }
            />
          </FloatingLabel>
          <FloatingLabel className="pb-2" label="새 비밀번호">
            <Form.Control
              placeholder="새 비밀번호"
              type="password"
              value={passwordInputs.newPw}
              onChange={(e) =>
                setPasswordInputs({
                  ...passwordInputs,
                  newPw: e.target.value,
                })
              }
            />
          </FloatingLabel>
          <FloatingLabel label="비밀번호 확인">
            <Form.Control
              placeholder="비밀번호 확인"
              type="password"
              value={passwordInputs.confirmPw}
              onChange={(e) =>
                setPasswordInputs({
                  ...passwordInputs,
                  confirmPw: e.target.value,
                })
              }
            />
          </FloatingLabel>
          <Form.Text className="ps-2">
            9자리 영문, 숫자로 입력해 주세요.
          </Form.Text>
        </Form>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default Setting;
